module.exports = __webpack_public_path__ + "static/media/iconfinder_github_3.c8f12c8c.png";